import { render, staticRenderFns } from "./IndicadoresResumoPreventiva.vue?vue&type=template&id=651af58a&scoped=true&"
import script from "./IndicadoresResumoPreventiva.vue?vue&type=script&lang=js&"
export * from "./IndicadoresResumoPreventiva.vue?vue&type=script&lang=js&"
import style0 from "./IndicadoresResumoPreventiva.vue?vue&type=style&index=0&id=651af58a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "651af58a",
  null
  
)

export default component.exports